<template>
	<div>
		<alert-product :data="node" :companyId="companyId" :productId="productId" :projectId="projectId" :preProductId="preProductId"
			:read_only='read_only'></alert-product>
	</div>
</template>

<script>
	import AlertProduct from "@/components/ProductComponents/AlertProduct";
  import WindowMixin from "@/pages/redirectWindows/Mixins/WindowMixin";
	export default {
		components: {
      AlertProduct,
		},
    mixins:[WindowMixin],
		data() {
			return {
				node: {},
        companyId: null,
        productId: null,
        preProductId:null,//上一个页面 方便返回
        projectId: null,
        read_only: false,
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>
</style>
